import { useEffect, useCallback } from 'react';

const BackgroundTaskListeners = ({ eventEmitter, immidiateApplyStoreAction }) => {
    const backgroundTaskStart = useCallback(task => {
        immidiateApplyStoreAction({
            type: 'BACKGROUND_TASK_START_SOCKET',
            payload: { task }
        });
    }, [immidiateApplyStoreAction]);

    const backgroundTaskProgress = useCallback(task => {
        immidiateApplyStoreAction({
            type: 'BACKGROUND_TASK_PROGRESS_SOCKET',
            payload: { task }
        });
    }, [immidiateApplyStoreAction]);

    const backgroundTaskFinish = useCallback(task => {
        immidiateApplyStoreAction({
            type: 'BACKGROUND_TASK_FINISH_SOCKET',
            payload: { task }
        });
    }, [immidiateApplyStoreAction]);

    const backgroundTaskError = useCallback(task => {
        immidiateApplyStoreAction({
            type: 'BACKGROUND_TASK_ERROR_SOCKET',
            payload: { task }
        });
    }, [immidiateApplyStoreAction]);


    const listen = () => {
        eventEmitter.on('background_task_start', backgroundTaskStart);
        eventEmitter.on('background_task_progress', backgroundTaskProgress);
        eventEmitter.on('background_task_finish', backgroundTaskFinish);
        eventEmitter.on('background_task_error', backgroundTaskError);

        return () => {
            eventEmitter.off('background_task_start', backgroundTaskStart);
            eventEmitter.off('background_task_progress', backgroundTaskProgress);
            eventEmitter.off('background_task_finish', backgroundTaskFinish);
            eventEmitter.off('background_task_error', backgroundTaskError);
        };
    };

    useEffect(listen, [backgroundTaskStart, backgroundTaskProgress, backgroundTaskFinish, backgroundTaskError]);

    return null;
}

export default BackgroundTaskListeners;
